import { render, staticRenderFns } from "./analysisPatientTable.vue?vue&type=template&id=2826b3e3"
import script from "./analysisPatientTable.vue?vue&type=script&lang=js"
export * from "./analysisPatientTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports